import { Popover } from '@mantine/core';
import { Elevation1_5 } from '@services/mantine';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  background-color: white;

  padding: 12px 16px 24px;

  /* Default in app */
  box-shadow: ${Elevation1_5.boxShadow};
  border-radius: 8px;
  max-width: 320px;
  width: 90vw;

  display: flex;
  flex-direction: column;
  row-gap: 16px;
  .OptionsSection {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const UpdatesMenuDropdown = styled(Popover.Dropdown)`
  && {
    background-color: transparent;
    padding: 0;
    border: none;
    box-shadow: unset;
  }
`;
